import { Component } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: "splash-screen",
    templateUrl: "./splash-screen.component.html",
    styleUrls: ["./splash-screen.component.scss"],
    imports: [NgStyle]
})
export class SplashScreenComponent {

  private loadingTimeMilliseconds: number = 750;
  private interval;
  windowWidth: string = "";
  showSplash = true;
  currentBarWidth: number = 0;

  constructor() {
    this.interval = setInterval(() => this.simulateLoading(), this.loadingTimeMilliseconds / 100);
  }

  simulateLoading() {
    if (this.currentBarWidth++ >= 100) {
      setTimeout(() => {
        this.showSplash = false;
        this.windowWidth = "-" + window.innerWidth + "px";
      }, 250);
      clearInterval(this.interval);
    }
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}